import React from "react";
import { Outlet } from "react-router-dom";
import { Body, Left, Right } from "../../assets/StyledComponent/CanteenAdmin/StyledCanteenDrawer";
import AvatarHeader from "../../shared/header/AvatarHeader/AvatarHeader";
import AdminDrawer from "../../shared/SideDrawer/AdminDrawer/AdminDrawer";

const index = () => {
  return (
    <> 
      <AvatarHeader/>
      <Body>
      <div className="d-flex w-100 mainBody">
      <Left>
        <AdminDrawer/>
      </Left>
      <Right>
     <Outlet/>
      </Right>
      </div>
      </Body>

    </>
  );
};

export default index;
